import Script from "next/script"
import Block from "@/components/wrappers/block"
import styles from "./active-campaign.module.css"
import classNames from "classnames"

export default function ActiveCampaign({ block }) {
  const { formId } = block.attrs
  const scriptSrc = `https://naturskyddsforeningen.activehosted.com/f/embed.php?id=${formId}`

  if (formId.length === 0) {
    return null
  }

  return (
    <>
      <Script src={scriptSrc} async></Script>
      <Block
        block={block}
        width="column"
        className={classNames(styles.wrapper, "_form_" + formId)}
      />
    </>
  )
}
